import React, { ReactElement } from 'react'
import { ITemplate } from '../../interfaces/Template'
import Header from '../../components/Header'
import Footer from '../../components/Footer'

function NoSidebarTemplate({ children }: ITemplate): ReactElement {
  return (
    <>
      <Header />
      <div className="containerFluid hFull miw0 flexGrow">
        <div className="row hFullMd">
          <div className="colMd12">
            <div className="templateContent">{children}</div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default NoSidebarTemplate
